
import React from 'react';
import { SearchX } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptySearchResultsProps {
  onResetFilters?: () => void;
}

const EmptySearchResults: React.FC<EmptySearchResultsProps> = ({ onResetFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="bg-slate-100 p-4 rounded-full mb-4">
        <SearchX className="h-10 w-10 text-slate-400" />
      </div>
      <h3 className="text-xl font-semibold mb-2">No trips found</h3>
      <p className="text-muted-foreground max-w-md mb-6">
        We couldn't find any trips matching your search criteria or filters. Try adjusting your search or filters.
      </p>
      
      {onResetFilters && (
        <Button onClick={onResetFilters} variant="outline">
          Reset all filters
        </Button>
      )}
    </div>
  );
};

export default EmptySearchResults;
